import React, { useEffect, useRef, useState } from 'react'
import OtpVerifyVisitor from './OtpVerifyVisitor';
import { mobileOTPSignup } from '../../api/auth';
import toast from 'react-hot-toast';
import { Button, Modal } from 'flowbite-react';
import "../Drawer/Drawer.css"
import { useNavigate } from 'react-router-dom';
import { showExistingAccountHint } from '../../utils/landingAuth';
import FieldError, { ButtonSpinner } from '../FieldError/FieldError';
import { getApiErrorMessage, validateLandingMobile } from '../../utils/landingForm';

const OtpSendVisitor = ({ isOpenModal, toggle }) => {
    const [mobile, setMobile] = useState('');
    const [openVerifyModal, setOpenVerifyModal] = useState(false);
    const [accountHint, setAccountHint] = useState(null);
    const [error, setError] = useState('');
    const [sending, setSending] = useState(false);
    const mobileInputRef = useRef(null);
    const navigate = useNavigate();

    const handleMobileChange = (e) => {
        const next = e.target.value.replace(/\D/g, '').slice(0, 10);
        setMobile(next);
        setAccountHint(null);
        if (error) setError('');
    };

    const toggleModal = () => {
        setOpenVerifyModal(!openVerifyModal);
    };

    useEffect(() => {
        if (isOpenModal && mobileInputRef.current) {
            mobileInputRef.current.focus();
        }
    }, [isOpenModal]);

    const mobileSend = async () => {
        const validationError = validateLandingMobile(mobile);
        if (validationError) {
            setError(validationError);
            return;
        }

        setSending(true);
        setError('');
        try {
            const mobileStatus = await mobileOTPSignup({
                mobile,
                visitor: true,
            });
            if (mobileStatus?.status >= 400) {
                setError(getApiErrorMessage(mobileStatus, 'Could not send OTP'));
                return;
            }
            const hint = showExistingAccountHint(mobileStatus);
            setAccountHint(hint);
            if (hint) {
                toast(hint, { icon: 'ℹ️' });
            } else {
                toast.success('OTP sent successfully');
            }
            setOpenVerifyModal(true);
            toggle();
        } catch (err) {
            setError(getApiErrorMessage(err, 'Could not send OTP. Please try again.'));
        } finally {
            setSending(false);
        }
    };

    return (
        <>
            <Modal className='' show={isOpenModal} size="sm" popup>
                <Modal.Body>
                    <div className="flex flex-col justify-center -mb-2">
                        <h1 className='text-2xl mb-3 mt-3 font-bold text-[#13224d]'>GET START FOR FREE</h1>
                        <h3 className="mb-2 text-md font-normal text-[#333333] ">
                            Enter your mobile number to receive a free OTP for quick verification.
                        </h3>
                        <div className='flex flex-col items-stretch mt-1 w-full'>
                            <input
                                ref={mobileInputRef}
                                onChange={handleMobileChange}
                                className={`custom-number-input border-[1px] border-dotted w-full rounded-lg placeholder:text-xs flex items-center ${
                                    error ? 'border-red-500 ring-1 ring-red-200' : 'border-slate-400'
                                }`}
                                type="text"
                                inputMode="numeric"
                                placeholder='Enter Your Mobile'
                                value={mobile}
                                maxLength={10}
                                disabled={sending}
                                aria-invalid={Boolean(error)}
                            />
                            <FieldError message={error} />
                        </div>
                        <div className="flex justify-end mt-4">
                            <Button
                                color="light"
                                size='sm'
                                disabled={sending}
                                onClick={() => {
                                    navigate("/");
                                    toggle();
                                }}
                            >
                                Back
                            </Button>
                            <Button
                                color="dark"
                                size='sm'
                                className='bg-primaryColor ms-2'
                                disabled={sending}
                                onClick={mobileSend}
                            >
                                {sending ? (
                                    <span className="inline-flex items-center gap-2">
                                        <ButtonSpinner /> Sending…
                                    </span>
                                ) : (
                                    'Send'
                                )}
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <OtpVerifyVisitor
                isOpenverifyModal={openVerifyModal}
                toggleModal={toggleModal}
                mobile={mobile}
                accountHint={accountHint}
                onAuthComplete={({ clearInputs } = {}) => {
                    if (!clearInputs) return;
                    setMobile('');
                    setAccountHint(null);
                    setError('');
                    setOpenVerifyModal(false);
                }}
            />
        </>
    );
};

export default OtpSendVisitor;
